<template>
  <div class="map" :style="{height:wapperHeight}">
    <ve-map
      :height="wapperHeight"
      :data="chartData"
      :extend="percentExtend"
      color="#fff"
      :settings="chartSettings"
    ></ve-map>
  </div>
</template>

<script>
import VeMap from 'v-charts/lib/map'
import mapOrigin from './china'

export default {
  components: { VeMap },
  name: 'mapChart',
  data () {
    let clientHeight = document.body.clientHeight
    function getValue (per) {
      return (per * clientHeight) / 100
    }

    this.chartSettings = {
      mapOrigin,
      position: 'china',
      dimension: '位置',
      metrics: ['人口', '面积'],
      dataType: {
        面积: 'KMB'
      },
      itemStyle: {
        areaColor: 'rgb(141, 198, 233)'

      },
      legend: {
        show: false
      },
      label: {
        show: true,
        fontWeight: 'bold'
      },
      nameMap: {
        'China': '中国'
      }
    }

    return {
      wapperHeight: getValue(55) + 'px',
      textStyle: {
        color: '#fff',
        fontWeight: 'bold'
      },
      percentExtend: {
        legend: {
          show: false
        }
      },
      chartData: {
        columns: ['位置', '税收', '人口', '面积'],
        rows: [
          { 位置: '吉林', 税收: 123, 人口: 123, 面积: 92134 },
          { 位置: '北京', 税收: 1223, 人口: 2123, 面积: 29234 },
          { 位置: '上海', 税收: 2123, 人口: 1243, 面积: 94234 },
          { 位置: '浙江', 税收: 4123, 人口: 5123, 面积: 29234 }
        ]
      }
    }
  },
  methods: {
    onHandleToggleDate (item, index) {
      this.tooggleDateIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  background-color: rgba(64, 162, 118, 0);
  border-image-source: url("../../image/border.png");
  border-image-slice: 10;
  border-image-width: 3;
  border-style: solid;
  box-sizing: border-box;
  width: 100%;
  padding:0 20px;
  height: 515px;
  touch-action: none;
}
</style>
